<template>

  <div id="app">
      <router-view/>
  </div>

</template>


<script>
import blog from './components/philosophans.vue'
import openprojects from './components/openprojects.vue'
import environments from './components/environments.vue'


export default {
  name: 'App',
  components: {
    blog,
    openprojects,
    environments
  }
}
</script>

<style>
body
{
  color: #444444;
  font-size: 14px;
  font-family: Century Gothic, Arial, Helvetica, sans-serif;
  margin-top: 30px;
  margin-bottom: 100px;
  padding: 0;
}

h1
{
  font-size: 32px;
}

h2
{
  font-size: 16px;
}

h3
{
  font-size: 14px;
  font-weight: normal;
}

h4
{
  font-size: 23px;
}

td
{
  font-size: 14px;
}

a:link
{
    color: #0000FF;
    text-decoration: none;
}

a:visited
{
    color: #0000FF;
    text-decoration: none;
}

a:hover, a:active
{
    color: #AA00AA;
    text-decoration: none;
}

.link_author {
	font-size: 12px;
}

.link_author_no{
	font-size: 12px;
	text-decoration: none;
}

.link_author_no:hover{
	font-size: 12px;
	text-decoration: none;
}


/* -----
SVG Icons - svgicons.sparkk.fr
----- */

.svg-icon {
  width: 1em;
  height: 1em;
}

.svg-icon path,
.svg-icon polygon,
.svg-icon rect {
  fill: #4691f6;
}

.svg-icon circle {
  stroke: #4691f6;
  stroke-width: 1;
}
</style>

<!--
<style scoped>

.body {
  height: 100%;
  background-color: "#000000";
  font-family: 'PT Mono', monospace;

}



.background {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}


div.container {
  height: 100%;
  padding: 2%;
  margin: 18%;
  display: flex;
  align-items: center;
  justify-content: center }
div.container p {
  margin: 0 }

.options {
  color:black;

}
.paragraph{
  width: 300px;
  height: 120px;
}

a {
 color: black;
 text-decoration: none;
}

a:hover {
  color: #920142;

}



</style>
-->



// WEBPACK FOOTER //
// src/App.vue